import { Box } from './LandingStyles'

const Cube = () => {
    return (<Box>
        <div class = 'zero'></div>
        <div class = 'one'></div>
        <div class = 'two'></div>
        <div class = 'three'></div>
        <div class = 'four'></div>
        <div class = 'five'></div>
    </Box>)
}

export default Cube;